import React, { FC } from "react";
import styled, { css } from "styled-components";
import { breakpoints } from "@theme/breakpoints";
import { Link, useI18next } from "gatsby-plugin-react-i18next";
import { useLocation } from "@reach/router";

const StyledWrapper = styled.ul`
  display: flex;
  list-style-type: none;
`;

const StyledItem = styled.li<{ $isActive: boolean }>`
  margin-right: 15px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${({ theme }) => theme.washRegular};
  display: flex;
  transition: color 0.2s ease-in-out;

  :last-child {
    margin-right: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      margin-top: 6px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: ${({ theme }) => theme.foreground};
      transform: scale(0);
      transition: transform 0.2s ease-in-out, background 0.2s ease-in-out;
    }
  }

  ${breakpoints.tabletMinMax`
    font-size: 1.8rem;
    margin-right: 20px;

  `};

  ${breakpoints.phoneMax`
    margin-right: 10px;
  `};

  ${({ $isActive, theme }) =>
    $isActive &&
    css`
      color: ${theme.foreground};

      a span {
        transform: scale(1);
      }
    `}
`;

export const LanguageSelector: FC = () => {
  const { pathname } = useLocation();
  const { defaultLanguage, languages, language, originalPath } = useI18next();

  return (
    <StyledWrapper>
      {languages.map((lang) => (
        <StyledItem key={lang} $isActive={language === lang}>
          <Link to={originalPath} language={lang}>
            {lang.toUpperCase()}
            <span />
          </Link>
        </StyledItem>
      ))}
    </StyledWrapper>
  );
};
